<div class="global-search-bar" *ngIf="showSearchBar">
  <div class="container-fluid px-3 px-lg-5">
    <!-- Mobile: stacked search + location + button -->
    <form
      class="mobile-search-form d-flex d-lg-none flex-column"
      (ngSubmit)="onSearch()"
    >
      <div class="mobile-breadcrumbs" *ngIf="mobileBreadcrumbs?.length">
        <ng-container *ngFor="let crumb of mobileBreadcrumbs; let last = last">
          <a *ngIf="crumb.url" [routerLink]="crumb.url" class="breadcrumb-link">{{ crumb.label }}</a>
          <span *ngIf="!crumb.url" class="breadcrumb-link">{{ crumb.label }}</span>
          <span class="breadcrumb-separator" *ngIf="!last">></span>
        </ng-container>
        <span class="breadcrumb-separator">></span>
      </div>
      <h1 class="mobile-search-heading" *ngIf="mobileHeading">{{ mobileHeading }}</h1>
      <div class="search-input-container w-100">
        <span class="icon-mag-glass text-grey search-icon"></span>
        <input
          type="text"
          class="form-control search-input"
          autocomplete="off"
          placeholder="Search equipment..."
          name="searchterm-mobile"
          [(ngModel)]="searchRequest.searchTerm"
          [ngbTypeahead]="searchTypeahead"
          [resultFormatter]="searchResultFormatter"
          (selectItem)="onSelectSearchSuggestion($event)"
        />
      </div>
      <div class="location-input-container w-100">
        <span class="icon-map text-grey location-icon"></span>
        <app-global-search-bar-location
          [location]="searchRequest.location.location"
          (locationSelected)="locationSelected($event)"
        ></app-global-search-bar-location>
        <button
          type="button"
          class="btn btn-location"
          title="Use my location"
          (click)="useMyLocation()"
        >
          <i class="icon-delivered"></i>
        </button>
      </div>
      <button type="submit" class="btn btn-danger search-btn w-100">
        <span class="icon-mag-glass"></span>
        <span>Search</span>
      </button>
    </form>

    <!-- Desktop: full search bar -->
    <form
      class="search-form d-none d-lg-flex align-items-center"
      (ngSubmit)="onSearch()"
    >
      <!-- Search Input -->
      <div class="search-input-container flex-grow-1">
        <span class="icon-mag-glass text-grey search-icon"></span>
        <input
          type="text"
          class="form-control search-input"
          autocomplete="off"
          placeholder="Search excavator, dozer, skid steer..."
          name="searchterm"
          [(ngModel)]="searchRequest.searchTerm"
          [ngbTypeahead]="searchTypeahead"
          [resultFormatter]="searchResultFormatter"
          (selectItem)="onSelectSearchSuggestion($event)"
        />
      </div>

      <!-- Location Input -->
      <div class="location-input-container d-none d-md-flex">
        <span class="icon-map text-grey location-icon"></span>
        <app-global-search-bar-location
          [location]="searchRequest.location.location"
          (locationSelected)="locationSelected($event)"
        ></app-global-search-bar-location>
        <button
          type="button"
          class="btn btn-location"
          title="Use my location"
          (click)="useMyLocation()"
        >
          <i class="icon-delivered"></i>
        </button>
      </div>

      <!-- Search Button -->
      <button type="submit" class="btn btn-danger search-btn">
        <span class="icon-mag-glass"></span>
        <span>Search</span>
      </button>
    </form>
  </div>
</div>
